import { useOptionsApi } from '@api/options.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void useOptionsApi()
})
